import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import BuildTime from './BuildTime';
import ce from './images/ce.svg';
import manufacturer from './images/manufacturer.png';
import manufacturingDate from './images/manufacturingDate.png';
import udi from './images/udi.png';

function Help() {
  return (
    <main id="instructions" className="textPage">
      {/* Product name is for MDR, annex I, clause 23.4, subclause a) (23.2 (a)). */}
      <h1>Ohjeet - Sensotrend Dashboard</h1>
      <ul className="toc">
        <li><Link to="/helpIntro">Palvelun esittely</Link></li> 
        <li><Link to="/helpGuidance">Käyttöohjeet</Link></li>
        <li><Link to="/helpTips">Tiedon hyödyntäminen</Link></li>
        <br /> 
        <li><Link to="/helpForPractitioner">Ammattilaisille</Link></li>
        <br /> 
        <li><Link to="#safety">Turvallisuustietoja</Link></li>
        <li><Link to="#label">Tuotetiedot</Link></li>
      </ul>
      <section id="safety">
        <h2>Turvallisuustietoja</h2>
        {/* Language reguirements are coming from finnish law 629/2010, 12 §*/}
        <small><Link to="/helpSE">Säkerhetsinformation på svenska</Link></small>
        {/* This section includes the "intended target groups with clear indications". 
          Ref. 
          - CLIN-T2-PL Clinical Evaluation Plan, clause 4.1, and
          - MDR annex XIV, clause 1, 3rd bullet 
        */}
        <h3>Sovelluksen käyttötarkoitus</h3>
        <p>
          {/* This is for MDR, annex I, clause 23.4, subclause b) (...intended purpose...).*/}
          Sensotrend Dashboard helpottaa diabeteksen hoitoa tuottamalla tietoa, jota hyödynnetään
          hoitotasapainon seurannassa ja hoitopäätöksiä tehtäessä. Palvelu yhdistää tietoa
          lääkinnällisistä laitteista ja hyvinvointisovelluksista sekä visualisoi tiedon tavalla,
          joka havainnollistaa eri tekijöiden vaikutusta verensokeritasoihin. Palvelu on
          tarkoitettu potilaiden, terveydenhuollon ammattilaisten ja muidenkin hoitoon
          osallistuvien tahojen käytettäväksi.
        </p>
        <p>
          {/* This one and the next one are for MDR, annex I, clause 23.4, subclause b)
          (...the patient target group or groups, and of the intended users...).
          */}
          Sensotrend Dashboard on suunniteltu hoidostaan vastuussa oleville diabeetikolle.
          Emme kuitenkaan halua rajoittaa sovelluksen käyttöä pelkästään tähän käyttäjäryhmään.
          Muilla käyttäjäryhmillä katsomme hoidosta vastuussa olevan tahon olevan vastuussa myös
          Sensotrend Dashboardin käytöstä.
        </p>
        <p>
          Perheenjäsenten tai vertaistuen osallistuminen sovelluksen käyttöön on sallittua
          sovelluksen käyttäjän luvalla. Tämä sisältää mahdollisuuden antaa perheenjäsenille tai
          vertaistuelle katseluluvat sovelluksen näyttämiin terveystietoihin.
        </p>
        {/* This section includes the "contra-indications". 
          Ref. 
          - CLIN-T2-PL Clinical Evaluation Plan, clause 4.1, and
          - MDR annex XIV, clause 1, 3rd bullet 
        */}
        <h3>Rajoituksia</h3>
        <p>
          {/* This is for R18 in RISK-T5-FM Risk Management File - Medical Issues.*/}
          Sovellus ei ole tarkoitettu terveydentilan reaaliaikaiseen seurantaan.
        </p>
        <p>
          {/* This clause is for MDR, annex I, clause 23.4, subclause w).*/}
          Sovelluksen käyttö ei korvaa terveydenhuollon ammattilaisen antamaa hoitoa, vaan
          täydentää sitä. Jos hoitotasapainossasi tapahtuu merkittäviä muutoksia, ota yhteyttä
          sinua hoitavaa terveydenhuollon yksikköön.
        </p>
        <p>
          {/* This is for R2 and R4 in RISK-T5-FM Risk Management File - Medical Issues.*/}
          Älä tee merkittäviä muutoksia hoitoosi pelkkien Sensotrend Dashboardin antamien tietojen
          perusteella. Ennen hoitopäätöstä tulee Sensotrend Dashboardin esittämiä tietoja verrata
          alkuperäisen tietolähteen tietoihin sen varmistamiseksi, että koko tiedonsiirtoketju on
          toiminut luotettavasti.
        </p>
        <p>
          {/* This clause is for MDR, annex I, clause 23.4 subclause z).*/}
          Jos sovelluksen käytön yhteydessä ilmenee vakavia vaaratilanteita, niistä tulee ilmoittaa
          asiakastukeemme <a href="mailto:tuki@sensotrend.com">tuki@sensotrend.com</a> ja
          valvontaviranomaiselle.
        </p>
        <h3>Järjestelmävaatimuksiin liittyviä tietoja</h3>
        <p>
          {/* This clause is for MDR, annex I, clause 23.4, subclause ab).*/}
          Sensotrend Dashboard on suunniteltu toimimaan nykyaikaisilla tietoteknisillä välineillä
          ja käytetyimmillä Internet-selaimilla. Toimintaa kaikilla markkinoilla olevilla
          kokoonpanoilla ei kuitenkaan pystytä erikseen varmistamaan. Jos havaitset virheellistä,
          odottamatonta tai puutteellista toimintaa, joka saattaa johtua käyttämistäsi laitteista
          tai ohjelmistoista, pyydämme sinua ottamaan yhteyttä asiakastukeemme <a
          href="mailto:tuki@sensotrend.com">tuki@sensotrend.com</a>, jotta voimme selvittää ja
          mahdollisuuksiemme mukaan korjata ongelman.
        </p>
        <p>
          Älä käytä sovellusta terveytesi ja hoitotasapainosi seurantaan, jos se vaikuttaa toimivan
          laitteellasi virheellisesti.
        </p>
      </section>
      <aside id="label">
        {/* This section includes the label. 
          Ref. MDR annex XIV, clause 1, 3rd bullet, and annex I, clause 23.2.
        */}
        <h2>Tuotetiedot</h2>
        {/* This clause is for MDR, annex I, clause 23.2, subclauses a) and b).*/}
        <p>Sensotrend Dashboard {`v.${process.env.REACT_APP_VERSION}`}</p>
        {/* This clause is for MDR, annex I, clause 23.2, subclause q).*/}

        <section id="ce">
          <figure>
            <img alt="CE" src={ce} />
          </figure>
          <p>Sensotrend Dashboard on luokan I lääkinnällinen laite.</p>
          <p>
            Ks. <a href={`${
              process.env.PUBLIC_URL
            }/DECO-T5-DC-MDD_EU_Declaration_of_Conformity_-_signed.pdf`}
           >vaatimustenmukaisuusvakuutus</a>.
          </p>
        </section>
        <section id="device">
            {/* This clause is for MDR, annex I, clause 23.2, subclause h).*/}
          <img alt="Laitetunniste" title="Laitetunniste" src={udi} />
          <p>D-FIMF000000500SD000001GS</p>
        </section>
        <section id="date">
            {/* Date of manufacture is for MDR, annex I, clause 23.2, subclause j).
              Date format is specified in ISO 1041:2008 & A1:2013, clause 4.4.
            */}
          <img alt="Valmistuspäivä" title="Valmistuspäivä" src={manufacturingDate} />
          {BuildTime}
        </section>
        <section id="manufacturer">
          <img alt="Valmistaja" title="Valmistaja" src={manufacturer} />
          <address>Sensotrend Oy<br />
            Tampellan esplanadi 19 A 55<br />
            33180 Tampere<br />
            <a href="mailto:tuki@sensotrend.com">tuki@sensotrend.com</a>
          </address>
        </section>
      </aside>
      <footer>
        {/* The date is for MDR, annex I, clause 23.4, subclause y).
            Date format is specified in ISO 1041:2008 & A1:2013, clause 4.4.
        */}
        <small>2021-06-11</small>
      </footer>
    </main>
  );
}

export default Help;
